import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { Action } from '../../../models/core/action';
import { MenuComponent } from '../panels/menu.component';
import { BaseControlComponent } from './base-control.component';
import { FormFieldComponent } from './form-field.component';

@Component({
  selector: 'app-operator-input',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
    FormFieldComponent,
    IconFieldModule,
    InputIconModule,
    InputNumberModule,
    InputMaskModule,
    MenuModule,
    InputGroupAddonModule,
    InputGroup,
    ButtonModule,
    MenuComponent,
  ],

  template: `
    <app-form-field
      [control]="control"
      [id]="id"
      [label]="label"
      [helpText]="helpText"
      [showHelpText]="showHelpText"
      [tooltip]="tooltip"
    >
      <div class="tw-flex tw-items-center">
        <p-inputgroup>
          <input
            #inputElement
            pInputText
            autocomplete="off"
            [formControl]="control"
            [id]="id"
            [attr.maxlength]="maxlength"
            [style]="{
              width: '100%',
              height: '38px',
              'border-radius': '6px 0 0 6px',
            }"
            [class]="{
              'ng-invalid': touchedInvalid,
              'ng-dirty': touchedInvalid,
            }"
          />
          <p-inputgroup-addon
            [style]="{
              width: '35px',
              height: '38px',
              padding: '0',
            }"
          >
            <button
              type="button"
              class="p-button p-button-icon-only p-button-secondary p-button-text"
              style="width: 35px; height: 38px; min-width: 35px;"
              aria-label="Operator options"
              [attr.aria-expanded]="isMenuExpanded"
              (click)="menu.toggle($event)"
            >
              <span
                class="p-button-icon fa-ellipsis-vertical fa-light"
                aria-hidden="true"
              ></span>
            </button>
          </p-inputgroup-addon>
        </p-inputgroup>
        <app-menu
          [items]="actions"
          #menu
          appendTo="body"
          (click)="setOperator($event.data)"
          (visibilityChange)="isMenuExpanded = $event"
        />
      </div>
    </app-form-field>
  `,
  styles: ``,
})
export class OperatorInputComponent extends BaseControlComponent implements OnInit {
  @ViewChild('inputElement', { read: ElementRef })
  inputElement: ElementRef;

  @Input()
  maxlength: number;

  @Input({ required: true })
  operatorControl: FormControl<string>;

  @Input({ required: true })
  operators: Operator[] = [
    {
      key: 'equals',
      placeholder: 'Equals',
      label: 'Equals',
    },
  ];

  /** Tracks menu expanded state for accessibility */
  isMenuExpanded = false;

  actions: Action[];

  async ngOnInit() {
    // if (this.placeholder) {
    //   this.inputElement.nativeElement.setAttribute(
    //     'placeholder',
    //     this.placeholder
    //   );
    // }

    const op =
      this.operators.find((x) => x.key === this.operatorControl.value) ??
      this.operators[0];
    this.operatorControl?.setValue(op.key);
    this.label = op.placeholder;

    this.actions = this.operators.map<Action>((op) => {
      const action = new Action();
      action.key = op.key;
      action.data = op;
      action.label = op.label;
      return action;
    });
  }

  protected setOperator(op: Operator) {
    this.operatorControl?.setValue(op.key);
    this.label = op.placeholder;
  }
}

export class Operator {
  label: string;

  placeholder: string;

  key: string;
}
